import React, { useCallback, useEffect, useState } from 'react'

import { API_URL } from '../../config/environments'
import { MAINTENANCE_EVENT, MaintenanceDetails } from '../../utils/maintenance'

import './MaintenanceGate.css'

const DEFAULT_MESSAGE =
  'Vloggi is temporarily unavailable while we complete scheduled maintenance. Please try again shortly.'

const MaintenanceGate = ({ children }: { children: React.ReactNode }) => {
  const [checking, setChecking] = useState(true)
  const [maintenance, setMaintenance] = useState<MaintenanceDetails | null>(null)

  const checkStatus = useCallback(async () => {
    try {
      const response = await fetch(`${API_URL}/health`, { cache: 'no-store' })
      const status = await response.json()
      setMaintenance(status.maintenance === true ? status : null)
    } catch (_error) {
      // A transient health-check failure should not replace a working session.
    } finally {
      setChecking(false)
    }
  }, [])

  useEffect(() => {
    const handleMaintenance = (event: Event) => {
      const details = (event as CustomEvent<MaintenanceDetails>).detail
      setMaintenance(details || { maintenance: true })
      setChecking(false)
    }

    window.addEventListener(MAINTENANCE_EVENT, handleMaintenance)
    checkStatus()
    const timer = window.setInterval(checkStatus, 15000)

    return () => {
      window.removeEventListener(MAINTENANCE_EVENT, handleMaintenance)
      window.clearInterval(timer)
    }
  }, [checkStatus])

  if (checking) return null
  if (!maintenance) return <>{children}</>

  return (
    <main className="maintenance-page" role="alert" aria-live="assertive">
      <section className="maintenance-card">
        <div className="maintenance-brand">vloggi</div>
        <div className="maintenance-icon" aria-hidden="true">
          ⏱
        </div>
        <h1>Scheduled maintenance</h1>
        <p>{maintenance.message || DEFAULT_MESSAGE}</p>
        <p>Uploads and account changes are paused. Your existing content is safe.</p>
        <button type="button" onClick={checkStatus}>
          Check again
        </button>
      </section>
    </main>
  )
}

export default MaintenanceGate
